(function ($) {
    'use strict';

    $.fn.firstVisitPopup = function (settings) {

        var $var_popup_wrapper;

        var setCookie = function (name, value) {
            var date = new Date(),
                expires = 'expires=';

            date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days
            expires += date.toGMTString();

            document.cookie = name + '=' + value + '; ' + expires + '; path=/';
        };

        var getCookie = function (name) {
            var allCookies = document.cookie.split(';'),
                cookieCounter = 0,
                currentCookie = '';

            for (cookieCounter = 0; cookieCounter < allCookies.length; cookieCounter++) {

                currentCookie = allCookies[cookieCounter];

                while (currentCookie.charAt(0) === ' ') {
                    currentCookie = currentCookie.substring(1, currentCookie.length);
                }

                if (currentCookie.indexOf(name + '=') === 0) {
                    return currentCookie.substring(
                        name.length + 1,
                        currentCookie.length
                    );
                }
            }

            return false;
        };

        /*
         * FIRST-TIME VISITOR POPUP
         * Show after 30 seconds
         */
        var showMessage = function () {

            setTimeout(function () {

                $var_popup_wrapper
                    .css({
                        "opacity": "1",
                        "visibility": "visible",
                        "transition": ".5s"
                    })
                    .fadeIn(500);

            }, 30000); // 30 SECONDS
        };

        var hideMessage = function () {

            $var_popup_wrapper.fadeOut(500);

            setCookie(
                'fvpp' + settings.cookieName,
                'true'
            );
        };

        $var_popup_wrapper = $('.popup_wrapper');

        // Check if user has already seen popup
        var hasSeenPopup = getCookie(
            'fvpp' + settings.cookieName
        );

        console.log(
            'First-time visitor check:',
            hasSeenPopup
                ? 'Has seen popup before'
                : 'First-time visitor'
        );

        if (hasSeenPopup) {

            // Already seen popup
            hideMessage();

        } else {

            // First visit
            showMessage();
        }

        // Close popup
        $(".popup_off")
            .off('click.firstVisitPopup')
            .on('click.firstVisitPopup', hideMessage);
    };

})(jQuery);


// ============================================
// INITIALIZE POPUP
// ============================================

$(document).ready(function () {

    // Homepage check
    var isHomepage =
        window.location.pathname === '/' ||
        window.location.pathname === '/index' ||
        window.location.pathname === '' ||
        window.location.pathname.match(/^\/$/) ||
        window.location.pathname.match(/^\/index$/);


    console.log('Newsletter popup initialization:');
    console.log('- Current path:', window.location.pathname);
    console.log('- Is homepage:', isHomepage);

    console.log(
        '- Newsletter enabled:',
        typeof window.newsletterPopupEnabled !== 'undefined'
            ? window.newsletterPopupEnabled
            : 'undefined'
    );

    console.log(
        '- First-time visitor mode:',
        typeof window.oneDayPopupEnabled !== 'undefined'
            ? window.oneDayPopupEnabled
            : 'undefined'
    );


    // Only run on homepage when newsletter popup is enabled
    if (
        isHomepage &&
        typeof window.newsletterPopupEnabled !== 'undefined' &&
        window.newsletterPopupEnabled
    ) {


        // ============================================
        // WAIT FOR POPUP ELEMENT
        // ============================================

        var checkPopup = setInterval(function () {

            if ($('#one-time-newsletter').length) {

                clearInterval(checkPopup);


                // ============================================
                // FIRST-TIME VISITOR MODE
                // ============================================

                if (
                    typeof window.oneDayPopupEnabled !== 'undefined' &&
                    window.oneDayPopupEnabled
                ) {

                    console.log(
                        'Using first-time visitor mode (cookie logic)'
                    );

                    $('#one-time-newsletter').firstVisitPopup({
                        cookieName: 'index'
                    });


                } else {


                    // ============================================
                    // ALWAYS SHOW MODE
                    // SHOW AFTER 30 SECONDS
                    // ============================================

                    console.log(
                        'Using always show mode (no cookie logic)'
                    );

                    setTimeout(function () {

                        $('.popup_wrapper').css({
                            "opacity": "1",
                            "visibility": "visible"
                        });

                        $('.popup_off')
                            .off('click.alwaysShow')
                            .on('click.alwaysShow', function () {

                                $(".popup_wrapper").fadeOut(200);

                            });

                    }, 30000); // 30 SECONDS
                }


                // ============================================
                // DON'T SHOW AGAIN
                // ============================================

                if (localStorage.getItem("DontShow")) {
                    $("#one-time-newsletter").hide();
                }


                $("#forgetMe").on("click", function () {

                    localStorage.setItem(
                        "DontShow",
                        "true"
                    );

                });


                // ============================================
                // SUCCESS MESSAGE CLOSE BUTTON
                // ============================================

                $('.success-form-close-btn').on('click', function () {

                    $('.form-message--success').slideToggle();

                });


                // ============================================
                // FORM SUBMISSION SUCCESS
                // ============================================

                $('form[id*="Contact_"]').on('submit', function (e) {

                    setTimeout(function () {

                        if ($('.form-message--success').length) {

                            setTimeout(function () {

                                $('.popup_wrapper').fadeOut(500);

                            }, 2000);

                        }

                    }, 100);

                });

            }

        }, 100);


        // ============================================
        // STOP CHECKING AFTER 10 SECONDS
        // ============================================

        setTimeout(function () {

            if (checkPopup) {
                clearInterval(checkPopup);
            }

        }, 10000);

    }

});